import { IProps } from '@/Interfaces/Icons/Props.interface';

const AnalyticsIcon = (props: IProps) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M4.66663 11.3337V8.66699' stroke='#3C6E71' strokeLinecap='round' />
      <path d='M8 11.3337V4.66699' stroke='#3C6E71' strokeLinecap='round' />
      <path d='M11.3334 11.333V7.33301' stroke='#3C6E71' strokeLinecap='round' />
      <path
        d='M1.66663 8.00033C1.66663 5.01477 1.66663 3.52199 2.59412 2.59449C3.52162 1.66699 5.0144 1.66699 7.99996 1.66699C10.9855 1.66699 12.4783 1.66699 13.4058 2.59449C14.3333 3.52199 14.3333 5.01477 14.3333 8.00033C14.3333 10.9859 14.3333 12.4787 13.4058 13.4062C12.4783 14.3337 10.9855 14.3337 7.99996 14.3337C5.0144 14.3337 3.52162 14.3337 2.59412 13.4062C1.66663 12.4787 1.66663 10.9859 1.66663 8.00033Z'
        stroke='#3C6E71'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default AnalyticsIcon;
